<div class="wrap">
  <h2>{{title}}</h2>
  <form [formGroup]="choiceClubForm" id="choiceClubForm" (ngSubmit)="onSubmit()">
   <mat-form-field appearance="outline">
     <mat-label>Choisir un club</mat-label>
      <mat-select formControlName="club" >
        <mat-option *ngFor="let c of  clubs" [value]="c.code">
         <strong>{{c.code }}</strong> - {{c.name}}
        </mat-option>
      </mat-select>
   </mat-form-field>
  </form>
  
  <div class="btn_action">
    <button type="button" class="back" (click)="dialogRef.close()">Fermer</button>
    <button type="submit" class="confirm" form="choiceClubForm" [disabled]="choiceClubForm.invalid" [style.opacity]="choiceClubForm.invalid? .5 : 1" appChangeColorTheme attribute="bgc">Go</button>

  </div>
</div>